import { createSelector } from '@reduxjs/toolkit';

import { json } from 'app/utils';
import { IGlobalState } from 'app/models';

export const getSession = createSelector(({ auth }: IGlobalState) => auth?.session, (session) => json.clone(session));
export const getUser = createSelector(({ auth }: IGlobalState) => auth?.session?.user, (user) => json.clone(user));

export const isPermitted = createSelector(
  ({ auth }: IGlobalState) => auth?.session?.permissions,
  (_: IGlobalState, key: string) => key,
  (permissions, key) => !!permissions?.includes(key),
);
